import { QdzElement, define } from '@qdz/element';

export class QdzQuantityInput extends QdzElement {
  get input() {
    return this.ref('input');
  }

  get min() {
    return Number(this.input.min) || 0;
  }

  get max() {
    return this.input.max === '' ? Infinity : Number(this.input.max);
  }

  get step() {
    return Number(this.input.step) || 1;
  }

  mount() {
    this.listen(this.ref('minus'), 'click', () => this.change(-1));
    this.listen(this.ref('plus'), 'click', () => this.change(1));
    this.listen(this.input, 'change', () => this.set(Number(this.input.value)));
    this.#sync();
  }

  change(direction) {
    this.set(Number(this.input.value) + direction * this.step);
  }

  set(value) {
    const steps = Math.round((value - this.min) / this.step);
    const snapped = this.min + Math.max(steps, 0) * this.step;
    const clamped = Math.min(Math.max(snapped, this.min), this.max);
    const changed = String(clamped) !== this.input.value || value !== clamped;
    this.input.value = String(clamped);
    this.#sync();
    if (changed) this.emit('quantity:change', { value: clamped, input: this.input });
  }

  #sync() {
    const value = Number(this.input.value);
    this.ref('minus').disabled = value <= this.min;
    this.ref('plus').disabled = value + this.step > this.max;
  }
}

define('qdz-quantity-input', QdzQuantityInput);
